import { TASK_CHOICE_MAPPING, TASK_KIND_MAPPING } from '@/types';

export const GROUP_OVERLAP_MESSAGE = 'You cannot add and remove the same groups.';
export const GROUP_NAMES_TOO_SHORT = 'The group name is too short.';
export const GROUP_NAMES_REPEAT = 'The group name(s) is already used.';
export const TAG_OVERLAP_MESSAGE = 'You cannot add and remove the same tags';

export const UPDATE_ROCKET_STATUS_OPTIONS = [
  'Pending - called but task list not complete',
  'Complete - task list now filled in',
  'Needs a call - willing to help this time?',
];

export const TASK_CHOICE_MAPPING_WITH_IDS = [
  TASK_CHOICE_MAPPING.Y,
  TASK_CHOICE_MAPPING.E,
  TASK_CHOICE_MAPPING.N,
  TASK_CHOICE_MAPPING.L,
  TASK_CHOICE_MAPPING.T,
  TASK_CHOICE_MAPPING.U,
  TASK_CHOICE_MAPPING.I,
  TASK_CHOICE_MAPPING.D,
  TASK_CHOICE_MAPPING.R,
  TASK_CHOICE_MAPPING[''],
];

export const TASK_KIND_MAPPING_WITH_IDS = [
  TASK_KIND_MAPPING.LB,
  TASK_KIND_MAPPING.HTV,
  TASK_KIND_MAPPING.PP,
  TASK_KIND_MAPPING.CAP,
  TASK_KIND_MAPPING.SCRUT,
  TASK_KIND_MAPPING.FP,
  TASK_KIND_MAPPING.DN,
  TASK_KIND_MAPPING.PHS,
  TASK_KIND_MAPPING.PHV,
  TASK_KIND_MAPPING.DE,
  TASK_KIND_MAPPING.TXT,
  TASK_KIND_MAPPING.STALL,
  TASK_KIND_MAPPING.OFC,
  TASK_KIND_MAPPING.EP,
  TASK_KIND_MAPPING.NO,
];

export const UPDATE_PATHWAY_OPTIONS = [
  { id: 1, label: 'Add new people only (not already on pathway)' },
  { id: 2, label: 'Add new & update existing people' },
  { id: 3, label: 'Add new & move existing people from any step' },
];
